import { Controller } from "@hotwired/stimulus"

// Adds and removes screenshot rows on the submission form.
export default class extends Controller {
  static targets = ["list", "template"]

  add(event) {
    event.preventDefault()
    const markup = this.templateTarget.innerHTML.replace(/NEW_RECORD/g, new Date().getTime())
    this.listTarget.insertAdjacentHTML("beforeend", markup)
  }

  remove(event) {
    event.preventDefault()
    const row = event.currentTarget.closest("[data-nested-row]")
    const destroyField = row.querySelector("input[name*='_destroy']")

    if (destroyField) {
      destroyField.value = "1"
      row.hidden = true
    } else {
      row.remove()
    }
  }
}
